/**
 * Интерактив страницы статьи блога:
 *  - аккордеоны (FAQ, редакционное примечание);
 *  - выбор оценки статьи (визуальный, без сохранения).
 *
 * Калькулятор микрокредита вынесен в отдельный компонент —
 * src/components/blocks/calculator/.
 */

function initAccordions() {
	const items = document.querySelectorAll(".article-accordion__item");

	items.forEach((item) => {
		const header = item.querySelector(".article-accordion__header");

		if (!header) return;

		header.addEventListener("click", () => {
			const isOpen = item.classList.toggle("is-open");
			header.setAttribute("aria-expanded", isOpen ? "true" : "false");
		});
	});
}

function initRating() {
	const widgets = document.querySelectorAll(".article-rate__stars");

	widgets.forEach((widget) => {
		const stars = Array.from(widget.querySelectorAll(".article-rate__star"));

		const paint = (count) => {
			stars.forEach((star, index) => {
				star.classList.toggle("is-active", index < count);
			});
		};

		stars.forEach((star, index) => {
			star.addEventListener("mouseenter", () => paint(index + 1));
			star.addEventListener("click", () => {
				widget.dataset.selected = String(index + 1);
				paint(index + 1);
			});
		});

		widget.addEventListener("mouseleave", () => {
			paint(parseInt(widget.dataset.selected, 10) || 0);
		});
	});
}

document.addEventListener("DOMContentLoaded", () => {
	initAccordions();
	initRating();
});
